import { Body, Button, Card, Headline, Icon } from "~/ui-library";
import { CheckCircleOutlineIcon } from "~/ui-library/icons";

export type SubCheckoutBillingAndPaymentProps = {
  disableAddPayment?: boolean;
  email: string;
  firstName: string;
  lastName: string;
  onAddButtonClick: () => void;
};

export const SubCheckoutBillingAndPayment: React.FC<
  SubCheckoutBillingAndPaymentProps
> = ({ disableAddPayment, email, firstName, lastName, onAddButtonClick }) => (
  <>
    <Card className="justify-center py-m">
      <Headline level={4} className="mx-m text-gray-800">
        Create Your Account
      </Headline>
      <Card className="mx-m mt-m flex flex-wrap items-center gap-s px-5 py-xs">
        <div className="w-fit">
          <Icon
            className="fill-transparent stroke-gray-800"
            SvgIcon={CheckCircleOutlineIcon}
          />
        </div>
        <div className="grow">
          <div className="text-body-small md:text-body-regular">
            {firstName} {lastName}
          </div>
          <div className="w-[160px] overflow-hidden text-ellipsis text-body-small text-gray-700 sm:w-fit md:text-body-regular">
            {email}
          </div>
        </div>
      </Card>
    </Card>
    <Card className="mt-s p-m">
      <Headline level={4}>Billing & Payment Information</Headline>
      <Body className="mb-m mt-xs">
        Add your billing and payment information to complete your free trial.
      </Body>
      <Button
        disabled={disableAddPayment}
        variant="primary"
        className="w-full"
        onClick={onAddButtonClick}
        data-testid="add-payment-button"
      >
        Add
      </Button>
    </Card>
  </>
);
